import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CrossProductSearchUserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CrossProductSearchUserDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aaId"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"isAaMastered"}},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CrossProductSearchUserDetails","document":CrossProductSearchUserDetailsDocument}} as const;
export type CrossProductSearchUserDetailsQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type CrossProductSearchUserDetailsQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'aaId' | 'avatarUrl' | 'email' | 'fullName' | 'isAaMastered'>
    & { nonPublic?: Types.Maybe<(
      { __typename: 'Member_NonPublic' }
      & Pick<Types.Member_NonPublic, 'avatarUrl' | 'fullName'>
    )> }
  )> }
);




/**
 * __useCrossProductSearchUserDetailsQuery__
 *
 * To run a query within a React component, call `useCrossProductSearchUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrossProductSearchUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrossProductSearchUserDetailsQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCrossProductSearchUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<CrossProductSearchUserDetailsQuery, CrossProductSearchUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrossProductSearchUserDetailsQuery, CrossProductSearchUserDetailsQueryVariables>(CrossProductSearchUserDetailsDocument, options);
      }
export function useCrossProductSearchUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrossProductSearchUserDetailsQuery, CrossProductSearchUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrossProductSearchUserDetailsQuery, CrossProductSearchUserDetailsQueryVariables>(CrossProductSearchUserDetailsDocument, options);
        }
export type CrossProductSearchUserDetailsQueryHookResult = ReturnType<typeof useCrossProductSearchUserDetailsQuery>;
export type CrossProductSearchUserDetailsLazyQueryHookResult = ReturnType<typeof useCrossProductSearchUserDetailsLazyQuery>;
export type CrossProductSearchUserDetailsQueryResult = Apollo.QueryResult<CrossProductSearchUserDetailsQuery, CrossProductSearchUserDetailsQueryVariables>;